'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Callout } from '@/components/Callout'
import { HowItWorksBlock } from '@/payload-types'
import { Media } from '@/components/Media'

export function HowItWorksClient(props: HowItWorksBlock) {
  return (
    <Section bgClassName="bg-olive-2">
      <div className="flex flex-col xl:flex-row justify-between gap-x-[80px]">
        <div className="xl:w-[300px]">
          <Callout
            eyebrow={{ label: 'How it works', color: 'powder' }}
            heading={props.heading}
            headingClassName="text-highlighter"
            content={props.description}
            variant="light"
          />
        </div>
        {typeof props.media === 'object' && (
          <div className="xl:flex-1">
            <Media resource={props.media} videoClassName="w-full aspect-video" controls />
          </div>
        )}
      </div>
    </Section>
  )
}
